import axios from "axios";
import { formatRub } from "./money";
import { canCancelByExpiry } from "./deadline";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// TZ8-3: минимальная цена платного (эскроу) задания
export const MIN_PAID_TASK_PRICE = 150;
export const MIN_PAID_TASK_PRICE_ERROR = "Минимальная цена платного задания — 150 ₽";

// TZ8-4: у переоткрытого задания отмена с возвратом доступна в open и discussing
export const isReopenedTask = (task) => !!(task && (task.reopened_at || task.previous_executor_id));

export const cancelConfirmText = (task) => {
  if (task.is_b2b) {
    return "Отменить задание от организации?\n\n" +
      "• Денег на платформе по этому заданию нет — возвратов не будет\n" +
      "• Задание ещё не подтверждено, поэтому закрывающие документы (договор, счёт, акт) не формируются\n" +
      "• Исполнитель, который обсуждал задание, получит уведомление об отмене";
  }
  if (canCancelByExpiry(task)) {
    return "Срок задания истёк, результат не сдан. Отменить задание с возвратом?\n\n" +
      "• Средства (основной платёж и доплаты) будут возвращены на вашу карту\n" +
      "• Исполнитель получит уведомление, отмена по истечении срока фиксируется в журнале\n" +
      "• Вместо отмены можно продлить срок кнопкой «Продлить срок»";
  }
  if (isReopenedTask(task)) {
    return "Отменить переоткрытое задание с возвратом?\n\n" +
      "• Оплаченная сумма (основной платёж и доплаты, если были) будет возвращена на вашу карту\n" +
      (task.status === "discussing" ? "• Обсуждение с текущим исполнителем завершится, он получит уведомление\n" : "") +
      "• Процесс возврата может занять до 3-5 рабочих дней";
  }
  return "Вы уверены, что хотите отменить это задание?\n\n" +
    "• Если задание было оплачено, средства будут возвращены на вашу карту\n" +
    "• Отменить можно только задания без принятого исполнителя\n" +
    "• Процесс возврата может занять до 3-5 рабочих дней";
};

export const cancelResultText = (data, task) => {
  const { refund_status: refundStatus, mock_mode: mockMode, refund_amount: refundAmount, surcharge_refund_amount: surchargeAmount } = data;
  // T4-8: состав возврата — основной платёж и доплаты (отдельные платежи)
  const surchargePart = surchargeAmount > 0 ? ` и доплату ${formatRub(surchargeAmount)}\u00a0₽ (всего ${formatRub(Number(refundAmount || 0) + Number(surchargeAmount))}\u00a0₽)` : "";
  if (refundStatus === "processing") {
    return { tone: "success", text: `Задание отменено. Возвращаем основной платёж ${formatRub(refundAmount)}\u00a0₽${surchargePart}: ${mockMode ? "возврат симулирован (тестовый режим)" : "средства поступят на карту в течение 3-5 рабочих дней"}.` };
  }
  if (refundStatus === "nothing_to_refund" && surchargeAmount > 0) {
    return { tone: "success", text: `Задание отменено. Основной платёж уже был возвращён ранее; возвращаем доплату ${formatRub(surchargeAmount)}\u00a0₽ — средства поступят на карту в течение 3-5 рабочих дней.` };
  }
  if (refundStatus === "no_payment_required") {
    return { tone: "success", text: task.is_b2b ? "Задание от организации отменено. Возвратов нет: расчёты проходят напрямую, документы не формируются." : "Задание отменено (платёж не требовался)." };
  }
  if (refundStatus === "no_refund_required") return { tone: "success", text: "Задание отменено (возврат не требуется)." };
  if (refundStatus === "failed") {
    return { tone: "error", text: "Задание отменено, но возникла проблема с возвратом средств. Обратитесь в поддержку: support@reversia.ru" };
  }
  return { tone: "success", text: (data.message || "Задание успешно отменено") + (data.estimated_completion ? ` Ожидаемое время возврата: ${data.estimated_completion}` : "") };
};

export const cancelErrorText = (error) => {
  const msg = error.response?.data?.detail || "Ошибка при отмене задания";
  return msg.includes("Cannot cancel task with status")
    ? "Нельзя отменить это задание. Исполнитель уже приступил к работе. Для решения спорных вопросов обратитесь в поддержку."
    : msg;
};

// Подтверждение + POST /cancel. Возвращает {text, tone} или null, если пользователь передумал.
export const confirmAndCancelTask = async (task) => {
  if (!window.confirm(cancelConfirmText(task))) return null;
  const response = await axios.post(`${API}/tasks/${task.id}/cancel`);
  return cancelResultText(response.data, task);
};
